module.exports = __webpack_public_path__ + "static/volg-627accfac0f88658d893b7a575e64b3f.png";